import { Helmet } from 'react-helmet-async'
import { useStore } from './hooks/useStore'
import classes from './Store.module.sass'
import { Button } from '../../../common/components/button/Button'
import { Modal } from '../../../common/components/modal/Modal'
import { List } from './components/list/List'
import { Form } from './components/form/Form'
import { Details } from './components/details/Details'
import { useSelector } from 'react-redux'
import { selectConnected } from '../../../store/slices/wsSlice'

export const Store = () => {
  const {
    getList,
    modalActive,
    setModalActive,
    startCreate,
    edit,
    startEdit,
    data,
    setData,
    list,
    detailsModalActive,
    setDetailsModalActive,
    showDetails,
    current,
    loading,
  } = useStore()

  const isConnected = useSelector(selectConnected)

  return (
    <div className={classes.container}>
      <Helmet>
        <title>{`Справочник торговых точек`}</title>
        <meta name="description" content={`Справочник торговых точек`} />
      </Helmet>
      <div className={classes.titleWithButtons}>
        <div className={classes.header}>Справочник торговых точек</div>
        <Button onClick={startCreate} text="Создать" disabled={!isConnected}/>
      </div>
      <List startEdit={startEdit} list={list} showDetails={showDetails} loading={loading} />
      <Modal modalActive={modalActive} setModalActive={setModalActive}>
        <Form
          edit={edit}
          data={data}
          setData={setData}
          getList={getList}
          setModalActive={setModalActive}
          el={current}
        />
      </Modal>
      <Modal modalActive={detailsModalActive} setModalActive={setDetailsModalActive}>
        <Details el={current} />
      </Modal>
    </div>
  )
}
